// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Svg from 'atoms/Svg'
import Link from 'atoms/Link'

// Images
import logoSvg from 'assets/logo.svg'

// Styles
const styles = theme => ({
  root: {
    width: 45,
    maxWidth: '100%',
    display: 'block',
    lineHeight: 0,
    color: theme.palette.text.primary,
    outline: 0,
  },
  contrast: {
    color: theme.palette.primary.contrastText,
  },
  largeOnDesktop: {
    [theme.breakpoints.up('sm')]: {
      width: 60,
    },
  },
})

export default
@withStyles(styles)
class LayoutLogo extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.any,
    contrast: PropTypes.bool,
    largeOnDesktop: PropTypes.bool,
  }

  render() {
    const { classes, className, contrast, largeOnDesktop } = this.props
    const cx = classNames(className, classes.root, {
      [classes.contrast]: contrast,
      [classes.largeOnDesktop]: largeOnDesktop,
    })
    return (
      <Link to="/" external className={cx} tabIndex="-1">
        <Svg {...logoSvg} />
      </Link>
    )
  }
}
